import React, { useEffect, useState } from 'react'
import { Button, Paper, TextField } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import List from './list';
import Create from './create';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import getCategoryService from '../../../services/getCategoryService';
import AddEdit from './addEdit';
import Loader from '../../../commonComponents/loader';

const validationSchema = Yup.object({
    name: Yup.string().required('Category name is required'),
});

const Category = () => {
    const [getdata, setGetData] = useState([]);
    const [editValue, setEditValue] = useState(null)
    const [openAddDialog, setOpenAddDialog] = useState(false)
    const [loading, setLoading] = useState(true); 
    
    const fetchData = async () => {
        try {
            const list = await getCategoryService.GetAllCategoryList();
            setGetData(list); 
            setLoading(false);
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        fetchData(); // Call fetchData initially when the component mounts
    }, []);

    const [editMode, setEditMode] = useState(false); // Track if in edit mode

    const validationSchema = Yup.object({
        name: Yup.string().required('Category name is required'),
    });

    // Formik setup for adding category
    const addFormik = useFormik({
        initialValues: {
            name: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            try {
                await getCategoryService.CreateCategory(values);
                resetForm();
                fetchData();
                // Optionally refetch data
            } catch (error) {
                console.error('Error adding category:', error);
            }
        },
    });

    // Formik setup for editing category

    const editFormik = useFormik({
        initialValues: {
            name: editValue?.name,
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values, { resetForm }) => {
            try {
                await getCategoryService.UpdateCategoryList(values, editValue.id);
                fetchData();
                resetForm();
                setEditMode(false); // Exit edit mode after successful edit
                // Optionally refetch data
            } catch (error) {
                console.error('Error editing category:', error);
            }
        },
    });
    return (
        <div className='container' >
            <div className='my-3 d-flex justify-content-end'>
                {/* <div>
                    {!editMode && (
                        <form onSubmit={addFormik.handleSubmit}>
                            <div>
                                <TextField
                                    size="small"
                                    label="Category Name"
                                    name="name"
                                    variant="outlined"
                                    value={addFormik.values.name}
                                    onChange={addFormik.handleChange}
                                    onBlur={addFormik.handleBlur}
                                    error={addFormik.touched.name && Boolean(addFormik.errors.name)}
                                    helperText={addFormik.touched.name && addFormik.errors.name}
                                />
                                <Button variant="outlined" type="submit" sx={{ marginLeft: '10px' }}>
                                    + Add Category
                                </Button>
                            </div>
                        </form>
                    )}
                    {editMode && (
                        <form onSubmit={editFormik.handleSubmit}>
                            <div>
                                <TextField
                                    size="small"
                                    label="Category Name"
                                    name="name"
                                    variant="outlined"
                                    value={editFormik.values.name}
                                    onChange={editFormik.handleChange}
                                    onBlur={editFormik.handleBlur}
                                    error={editFormik.touched.name && Boolean(editFormik.errors.name)}
                                    helperText={editFormik.touched.name && editFormik.errors.name}
                                />
                                <Button variant="outlined" type="submit" sx={{ marginLeft: '10px' }}>
                                    Edit Category
                                </Button>
                            </div>
                        </form>
                    )}
                </div> */}
                <Button variant="outlined" type="button" sx={{ marginLeft: '10px' }} onClick={() => setOpenAddDialog(true)} >
                    + Add Category
                </Button>

            </div>
          

            {loading ? (
                <div className="text-center my-3">
                    <Loader />
                </div>
            ) : (
                <List setEditValue={setEditValue} getdata={getdata} setEditMode={setEditMode} setOpenAddDialog={setOpenAddDialog} setGetData={setGetData} fetchData={fetchData} />
            )}
            <AddEdit setOpenAddDialog={setOpenAddDialog} openAddDialog={openAddDialog} editValue={editValue} setEditValue={setEditValue} fetchData={fetchData} />
        </div>
    )
}

export default Category